import React from 'react';
import { TDeviceType } from '@cian/ui-kit/responsive';
import cn from 'classnames';

import { Section } from '../Section';
import { HeroSectionActions } from '../HeroSectionActions';
import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../types/mediaQueries';
import { HERO_IMAGE } from '../../constants/heroImage';

import * as styles from './styles.css';

export const HeroSection: React.FC<{
  deviceType: TDeviceType;
  onOpenVideoClick(): void;
  onCreateDealClick(): void;
}> = props => {
  const { deviceType } = props;

  return (
    <div className={cn(styles['background'], styles[deviceType])}>
      <Section className={cn(styles['section'], styles[deviceType])}>
        <picture className={cn(styles['image-wrapper'], styles[deviceType])}>
          <source srcSet={HERO_IMAGE.x2} media={X2_IMAGE_SIZE_MEDIA_QUERY} />
          <img src={HERO_IMAGE.x1} alt="Проведение сделки онлайн" />
        </picture>
        <div>
          <h2 className={cn(styles['heading'], styles[deviceType])}>Циан.Сделка — безопасно, быстро и комфортно</h2>
          <p className={cn(styles['subtitle'], styles[deviceType])}>
            Купите или продайте недвижимость в РФ из любой точки мира
          </p>
          <HeroSectionActions {...props} />
        </div>
      </Section>
    </div>
  );
};
